(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barra-anuncios"] && !Shopify.designMode) return;
  try {
    
(function() {
  var barras = document.querySelectorAll('.barra-anuncios');

  barras.forEach(function(barra) {
    var pista = barra.querySelector('[data-pista]');
    if (!pista) return;

    var items = pista.querySelectorAll('.barra-anuncios__item');
    var puntos = barra.querySelectorAll('[data-punto]');
    var flechaAnterior = barra.querySelector('[data-flecha-anterior]');
    var flechaSiguiente = barra.querySelector('[data-flecha-siguiente]');
    var total = items.length;
    var actual = 0;
    var autoplay = barra.getAttribute('data-autoplay') === 'true';
    var velocidad = parseInt(barra.getAttribute('data-velocidad'), 10) || 5;
    var intervalo = null;

    if (total <= 1) return;

    function irA(indice) {
      actual = (indice + total) % total;
      pista.style.transform = 'translateX(-' + (actual * (100 / total)) + '%)';

      puntos.forEach(function(punto, i) {
        punto.classList.toggle('barra-anuncios__punto--activo', i === actual);
      });
    }

    function siguiente() {
      irA(actual + 1);
    }

    function anterior() {
      irA(actual - 1);
    }

    function iniciarAutoplay() {
      if (!autoplay) return;
      detenerAutoplay();
      intervalo = setInterval(siguiente, velocidad * 1000);
    }

    function detenerAutoplay() {
      if (intervalo) {
        clearInterval(intervalo);
        intervalo = null;
      }
    }

    if (flechaSiguiente) {
      flechaSiguiente.addEventListener('click', function() {
        siguiente();
        iniciarAutoplay();
      });
    }

    if (flechaAnterior) {
      flechaAnterior.addEventListener('click', function() {
        anterior();
        iniciarAutoplay();
      });
    }

    puntos.forEach(function(punto) {
      punto.addEventListener('click', function() {
        irA(parseInt(punto.getAttribute('data-indice'), 10));
        iniciarAutoplay();
      });
    });

    barra.addEventListener('mouseenter', detenerAutoplay);
    barra.addEventListener('mouseleave', iniciarAutoplay);

    var inicioX = 0;

    pista.addEventListener('touchstart', function(e) {
      inicioX = e.changedTouches[0].screenX;
    }, { passive: true });

    pista.addEventListener('touchend', function(e) {
      var finX = e.changedTouches[0].screenX;
      var diferencia = inicioX - finX;
      if (Math.abs(diferencia) > 40) {
        if (diferencia > 0) {
          siguiente();
        } else {
          anterior();
        }
        iniciarAutoplay();
      }
    }, { passive: true });

    irA(0);
    iniciarAutoplay();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-producto"] && !Shopify.designMode) return;
  try {
    
(function() {
  var secciones = document.querySelectorAll('.hero-producto');

  secciones.forEach(function(seccion) {
    var pistaMiniaturas = seccion.querySelector('[data-miniaturas-pista]');

    if (pistaMiniaturas) {
      pistaMiniaturas.addEventListener('click', function(evento) {
        var miniatura = evento.target.closest('[data-miniatura]');
        if (!miniatura) return;

        var imagenPrincipal = seccion.querySelector('[data-imagen-principal] img');
        var nuevaImagen = miniatura.getAttribute('data-imagen-grande');

        if (imagenPrincipal && nuevaImagen && nuevaImagen.length > 0) {
          imagenPrincipal.src = nuevaImagen;
        }

        var todasMiniaturas = pistaMiniaturas.querySelectorAll('[data-miniatura]');
        todasMiniaturas.forEach(function(m) {
          m.classList.remove('hero-producto__miniatura--activa');
        });
        miniatura.classList.add('hero-producto__miniatura--activa');
      });
    }

    var botonesAcordeon = seccion.querySelectorAll('[data-acordeon-boton]');
    botonesAcordeon.forEach(function(boton) {
      boton.addEventListener('click', function() {
        var acordeon = boton.closest('.hero-producto__acordeon');
        if (acordeon) {
          acordeon.classList.toggle('hero-producto__acordeon--abierto');
        }
      });
    });

    var planes = seccion.querySelectorAll('[data-plan]');
    var inputId = seccion.querySelector('[data-id-input]');

    planes.forEach(function(plan) {
      var radio = plan.querySelector('[data-radio-plan]');

      plan.addEventListener('click', function() {
        planes.forEach(function(p) {
          p.classList.remove('hero-producto__plan--seleccionado');
        });
        plan.classList.add('hero-producto__plan--seleccionado');

        if (radio) {
          radio.checked = true;
        }

        if (inputId) {
          inputId.value = plan.getAttribute('data-variant-id');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preguntas-frecuentes"] && !Shopify.designMode) return;
  try {
    
(function() {
  var secciones = document.querySelectorAll('.preguntas-frecuentes');

  secciones.forEach(function(seccion) {
    var lista = seccion.querySelector('.preguntas-frecuentes__lista');
    var multiples = lista ? lista.getAttribute('data-multiples') === 'true' : true;
    var items = seccion.querySelectorAll('.preguntas-frecuentes__item');

    items.forEach(function(item) {
      var boton = item.querySelector('[data-boton-pregunta]');
      if (!boton) return;

      boton.addEventListener('click', function() {
        var estaActivo = item.classList.contains('preguntas-frecuentes__item--activo');

        if (!multiples) {
          items.forEach(function(otro) {
            if (otro !== item) {
              otro.classList.remove('preguntas-frecuentes__item--activo');
            }
          });
        }

        item.classList.toggle('preguntas-frecuentes__item--activo', !estaActivo);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-producto"] && !Shopify.designMode) return;
  try {
    
(function() {
  var secciones = document.querySelectorAll('.resenas');

  secciones.forEach(function(seccion) {
    var botonesLeerMas = seccion.querySelectorAll('[data-boton-leer-mas]');

    botonesLeerMas.forEach(function(boton) {
      boton.addEventListener('click', function() {
        var texto = boton.previousElementSibling;
        if (!texto) return;
        var expandido = texto.classList.toggle('resenas__texto-resena--expandido');
        boton.textContent = expandido ? 'Leer menos' : 'Leer más';
      });
    });

    var filtros = seccion.querySelectorAll('.resenas__filtro');
    var tarjetas = seccion.querySelectorAll('.resenas__tarjeta');

    filtros.forEach(function(filtro) {
      filtro.addEventListener('click', function() {
        var valor = filtro.getAttribute('data-filtro');

        filtros.forEach(function(f) {
          f.classList.remove('resenas__filtro--activo');
        });
        filtro.classList.add('resenas__filtro--activo');

        tarjetas.forEach(function(tarjeta) {
          if (valor === 'todas') {
            tarjeta.removeAttribute('data-oculta');
          } else {
            var calificacion = tarjeta.getAttribute('data-calificacion');
            if (calificacion === valor) {
              tarjeta.removeAttribute('data-oculta');
            } else {
              tarjeta.setAttribute('data-oculta', 'true');
            }
          }
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selector-oferta"] && !Shopify.designMode) return;
  try {
    
(function() {
  var selectores = document.querySelectorAll('.selector-oferta');

  selectores.forEach(function(selector) {
    var planes = selector.querySelectorAll('[data-plan]');
    var inputCantidad = selector.querySelector('[data-cantidad-input]');

    planes.forEach(function(plan) {
      var radio = plan.querySelector('[data-radio-plan]');

      plan.addEventListener('click', function() {
        planes.forEach(function(p) {
          p.classList.remove('selector-oferta__plan--seleccionado');
        });
        plan.classList.add('selector-oferta__plan--seleccionado');

        if (radio) {
          radio.checked = true;
        }

        if (inputCantidad) {
          inputCantidad.value = plan.getAttribute('data-cantidad');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
